(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cleveree-rating-breakdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cleveree-product-reviews')) {
  customElements.define('cleveree-product-reviews', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.items = [...this.querySelectorAll('[data-review-item]')];
      this.filters = [...this.querySelectorAll('[data-review-filter]')];
      this.dialog = this.querySelector('dialog');
      this.heading = this.querySelector('[data-review-heading]');
      this.empty = this.querySelector('[data-review-empty]');
      this.closeButton = this.querySelector('[data-review-close]');
      this.filters.forEach(filter => filter.addEventListener('click', () => this.openReviews(filter), {signal}));
      this.closeButton.addEventListener('click', () => this.dialog.close(), {signal});
      this.dialog.addEventListener('close', () => this.restorePage(), {signal});
      this.dialog.addEventListener('pointerdown', event => {
        const rect = this.dialog.getBoundingClientRect();
        this.backdropDown = event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
      }, {signal});
      this.dialog.addEventListener('click', event => {
        const rect = this.dialog.getBoundingClientRect();
        if (this.backdropDown && (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom)) this.dialog.close();
        this.backdropDown = false;
      }, {signal});
    }
    openReviews(trigger) {
      const rating = trigger.dataset.reviewFilter;
      const matches = this.items.filter(item => rating === 'all' || item.dataset.reviewRating === rating);
      this.items.forEach(item => {item.hidden = !matches.includes(item);});
      this.heading.textContent = (rating === 'all' ? this.dataset.all : this.dataset.filtered.replace('[rating]',rating)) + ' (' + matches.length + ')';
      this.empty.hidden = matches.length !== 0;
      this.trigger = trigger;
      this.filters.forEach(filter => filter.setAttribute('aria-expanded',String(filter === trigger)));
      if (!this.dialog.open) {
        this.originalOverflow = document.documentElement.style.overflow;
        this.scrollLocked = true;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }
      this.dialog.querySelector('.cl-rb-dialog-body').scrollTop = 0;
      this.closeButton.focus({preventScroll:true});
    }
    restorePage() {
      if (this.scrollLocked) document.documentElement.style.overflow = this.originalOverflow;
      this.scrollLocked = false;
      this.filters.forEach(filter => filter.setAttribute('aria-expanded','false'));
      if (this.trigger?.isConnected) this.trigger.focus({preventScroll:true});
    }
    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
      this.restorePage();
      this.controller?.abort();
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["cleveree-scratch-reveal"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('cleveree-scratch')) {
    class ClevereeScratch extends HTMLElement {
      connectedCallback() {
        queueMicrotask(() => { if (this.isConnected) this.init(); });
      }

      disconnectedCallback() { this.destroy(); }

      init() {
        if (this.controller) return;
        this.offer = this.querySelector('.cl-discount-code');
        this.copyButton = this.querySelector('.cl-discount-copy');
        this.canvas = this.querySelector('canvas');
        this.tap = this.querySelector('.cl-scratch-tap');
        this.status = this.querySelector('.cl-scratch-status');
        if (!this.offer || !this.copyButton || !this.canvas || !this.tap) return;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.code = this.copyButton.dataset.code;
        this.storageKey = 'cleveree-scratch:v1:' + this.id + ':' + this.code;
        this.threshold = Math.min(90, Math.max(5, Number(this.dataset.threshold) || 35)) / 100;
        this.motion = matchMedia('(prefers-reduced-motion: reduce)');
        this.width = this.height = this.dpr = 0;
        this.strokes = [];
        this.pointerId = null;
        this.started = false;
        this.revealed = false;
        this.removeAttribute('data-revealed');
        this.copyButton.addEventListener('click', () => this.copy(), options);
        this.tap.addEventListener('click', (event) => this.reveal(event.detail === 0), options);
        this.mail = this.querySelector('.cl-scratch-mail');
        if (this.mail) {
          this.mail.addEventListener('submit', (event) => this.sendMail(event), options);
          this.mail.addEventListener('focusin', () => clearTimeout(this.redirectTimer), options);
          if (this.mail.querySelector('.cl-scratch-mail__done')) this.showNormally();
        }
        this.canvas.addEventListener('pointerdown', (event) => this.start(event), options);
        this.canvas.addEventListener('pointermove', (event) => this.move(event), options);
        ['pointerup', 'pointercancel', 'lostpointercapture'].forEach((name) => {
          this.canvas.addEventListener(name, () => this.end(), options);
        });
        try {
          this.context = this.canvas.getContext('2d');
          this.base = document.createElement('canvas');
          this.baseContext = this.base.getContext('2d');
          this.mask = document.createElement('canvas');
          this.maskContext = this.mask.getContext('2d', { willReadFrequently: true });
          let saved = false;
          try { saved = sessionStorage.getItem(this.storageKey) === '1'; } catch (_) {}
          if (this.dataset.enabled !== 'true' || !this.code || saved || !this.context || !this.baseContext || !this.maskContext || !window.PointerEvent || !window.ResizeObserver) {
            this.showNormally();
            return;
          }
          this.resize();
          if (!this.width || !this.height) { this.showNormally(); return; }
          this.setAttribute('data-locked', '');
          this.offer.setAttribute('aria-hidden', 'true');
          this.copyButton.disabled = true;
          this.canvas.hidden = false;
          this.canvas.style.opacity = '1';
          this.tap.hidden = false;
          this.observer = new ResizeObserver(() => {
            if (!this.revealed) {
              try { this.resize(); } catch (_) { this.showNormally(); }
            }
          });
          this.observer.observe(this.offer);
          window.addEventListener('resize', () => {
            if (!this.revealed) {
              try { this.resize(); } catch (_) { this.showNormally(); }
            }
          }, options);
          this.motion.addEventListener('change', () => this.animate(), options);
          document.addEventListener('visibilitychange', () => this.animate(), options);
          if (window.IntersectionObserver) {
            this.visibilityObserver = new IntersectionObserver((entries) => {
              this.inView = entries[0].isIntersecting;
              this.animate();
            });
            this.visibilityObserver.observe(this);
          } else { this.inView = true; this.animate(); }
        } catch (_) { this.showNormally(); }
      }

      resize() {
        const rect = this.offer.getBoundingClientRect();
        const dpr = window.devicePixelRatio || 1;
        if (!rect.width || !rect.height) return;
        if (this.width === rect.width && this.height === rect.height && this.dpr === dpr) return;
        this.width = rect.width;
        this.height = rect.height;
        this.dpr = dpr;
        for (const surface of [this.canvas, this.base]) {
          surface.width = Math.round(this.width * dpr);
          surface.height = Math.round(this.height * dpr);
        }
        this.context.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.baseContext.setTransform(dpr, 0, 0, dpr, 0, 0);
        this.mask.width = 180;
        this.mask.height = Math.max(1, Math.round(180 * this.height / this.width));
        this.maskContext.setTransform(this.mask.width / this.width, 0, 0, this.mask.height / this.height, 0, 0);
        this.maskContext.fillStyle = '#fff';
        this.maskContext.fillRect(0, 0, this.width, this.height);
        this.paintBase();
        this.paint();
        for (const stroke of this.strokes) {
          this.erase(this.context, stroke);
          this.erase(this.maskContext, stroke);
        }
      }

      paintBase() {
        const ctx = this.baseContext;
        const gradient = ctx.createLinearGradient(0, 0, this.width, this.height);
        gradient.addColorStop(0, this.dataset.start || '#ffd18e');
        gradient.addColorStop(1, this.dataset.end || '#e48a47');
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, this.width, this.height);
        ctx.strokeStyle = 'rgba(255,255,255,.075)';
        ctx.lineWidth = .5;
        ctx.beginPath();
        for (let x = -this.height; x < this.width; x += 4) {
          ctx.moveTo(x, 0); ctx.lineTo(x + this.height, this.height);
        }
        ctx.stroke();
        ctx.strokeStyle = 'rgba(255,248,232,.65)';
        ctx.lineWidth = 1;
        ctx.strokeRect(1.5, 1.5, this.width - 3, this.height - 3);
      }

      paint(time) {
        const ctx = this.context;
        ctx.globalCompositeOperation = 'source-over';
        ctx.clearRect(0, 0, this.width, this.height);
        ctx.drawImage(this.base, 0, 0, this.width, this.height);
        if (time !== undefined) {
          const phase = (time % 7000) / 2400;
          if (phase <= 1) {
            const x = -this.width * .5 + phase * this.width * 2;
            const shine = ctx.createLinearGradient(x - this.width * .25, 0, x + this.width * .25, this.height);
            shine.addColorStop(0, 'rgba(255,255,255,0)');
            shine.addColorStop(.5, 'rgba(255,255,255,.22)');
            shine.addColorStop(1, 'rgba(255,255,255,0)');
            ctx.fillStyle = shine;
            ctx.fillRect(0, 0, this.width, this.height);
          }
        }
      }

      animate() {
        cancelAnimationFrame(this.frame);
        if (this.revealed || this.started || !this.inView || document.hidden || this.motion.matches) return;
        const tick = (time) => {
          if (!this.lastFrame || time - this.lastFrame >= 50) {
            this.paint(time); this.lastFrame = time;
          }
          this.frame = requestAnimationFrame(tick);
        };
        this.frame = requestAnimationFrame(tick);
      }

      point(event) {
        const rect = this.canvas.getBoundingClientRect();
        return { x: (event.clientX - rect.left) / rect.width, y: (event.clientY - rect.top) / rect.height };
      }

      start(event) {
        if (this.revealed || this.pointerId !== null || !event.isPrimary || (event.pointerType === 'mouse' && event.button !== 0)) return;
        this.started = true;
        cancelAnimationFrame(this.frame);
        this.pointerId = event.pointerId;
        this.previous = this.point(event);
        this.brush = (event.pointerType === 'mouse' ? 40 : 50) / this.width;
        try { this.canvas.setPointerCapture(event.pointerId); } catch (_) {}
        this.scratch(this.previous, this.previous);
        this.checkCoverage();
      }

      move(event) {
        if (event.pointerId !== this.pointerId || this.revealed) return;
        const next = this.point(event);
        this.scratch(this.previous, next);
        this.previous = next;
        if (!this.lastCheck || performance.now() - this.lastCheck > 100) this.checkCoverage();
      }

      scratch(from, to) {
        const stroke = { from, to, brush: this.brush };
        this.strokes.push(stroke);
        this.erase(this.context, stroke);
        this.erase(this.maskContext, stroke);
      }

      erase(ctx, stroke) {
        const x = stroke.to.x * this.width;
        const y = stroke.to.y * this.height;
        ctx.globalCompositeOperation = 'destination-out';
        ctx.fillStyle = '#000';
        ctx.strokeStyle = '#000';
        ctx.lineWidth = stroke.brush * this.width;
        ctx.lineCap = 'round';
        ctx.lineJoin = 'round';
        ctx.beginPath();
        ctx.moveTo(stroke.from.x * this.width, stroke.from.y * this.height);
        ctx.lineTo(x, y);
        ctx.stroke();
        ctx.beginPath();
        ctx.arc(x, y, ctx.lineWidth / 2, 0, Math.PI * 2);
        ctx.fill();
      }

      end() {
        if (this.pointerId === null) return;
        const pointer = this.pointerId;
        this.pointerId = null;
        try { if (this.canvas.hasPointerCapture(pointer)) this.canvas.releasePointerCapture(pointer); } catch (_) {}
        this.checkCoverage();
      }

      checkCoverage() {
        if (this.revealed) return;
        this.lastCheck = performance.now();
        try {
          const pixels = this.maskContext.getImageData(0, 0, this.mask.width, this.mask.height).data;
          let erased = 0;
          for (let i = 3; i < pixels.length; i += 4) erased += 1 - pixels[i] / 255;
          if (erased / (pixels.length / 4) >= this.threshold) this.reveal(false);
        } catch (_) { this.showNormally(); }
      }

      showNormally() {
        this.revealed = true;
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.removeAttribute('data-locked');
        this.setAttribute('data-revealed', '');
        this.offer.removeAttribute('aria-hidden');
        this.copyButton.disabled = false;
        this.canvas.hidden = true;
        this.tap.hidden = true;
      }

      reveal(focusCopy) {
        if (this.revealed) return;
        this.revealed = true;
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.visibilityObserver?.disconnect();
        this.pointerId = null;
        try { sessionStorage.setItem(this.storageKey, '1'); } catch (_) {}
        this.canvas.style.opacity = '0';
        this.tap.hidden = true;
        this.fadeTimer = setTimeout(() => {
          this.showNormally();
          this.setAttribute('data-highlight', '');
          this.status.textContent = this.code;
          if (focusCopy) this.copyButton.focus({ preventScroll: true });
        }, this.motion.matches ? 0 : 380);
      }

      async copy() {
        if (this.copyButton.disabled || this.copying) return;
        this.copying = true;
        const controller = this.controller;
        let copied = false;
        try {
          if (window.isSecureContext && navigator.clipboard?.writeText) {
            await navigator.clipboard.writeText(this.code);
            copied = true;
          }
        } catch (_) {}
        if (controller.signal.aborted) { this.copying = false; return; }
        if (!copied) {
          const field = document.createElement('textarea');
          const active = document.activeElement;
          field.value = this.code;
          field.readOnly = true;
          field.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;font-size:16px;';
          this.appendChild(field);
          field.focus({ preventScroll: true });
          field.select();
          field.setSelectionRange(0, field.value.length);
          try { copied = document.execCommand('copy'); } catch (_) {}
          field.remove();
          active?.focus({ preventScroll: true });
        }
        this.copying = false;
        if (copied) {
          clearTimeout(this.copyTimer);
          const confirmation = this.dataset.confirmation || 'COPIED';
          this.querySelector('.cl-scratch-copy-feedback').textContent = confirmation;
          this.copyButton.setAttribute('data-copied', 'true');
          this.copyButton.setAttribute('aria-label', confirmation);
          this.status.textContent = confirmation + ' · Taking you to the shop…';
          const typing = this.mail && (this.mail.contains(document.activeElement) || (this.mail.querySelector('input[type=email]')?.value || '').trim());
          if (this.dataset.redirect && !typing) this.redirectTimer = setTimeout(() => { window.location.assign(this.dataset.redirect); }, 2200);
          this.copyTimer = setTimeout(() => {
            this.copyButton.removeAttribute('data-copied');
            this.copyButton.removeAttribute('aria-label');
            this.status.textContent = '';
          }, 1800);
        } else {
          const selection = window.getSelection();
          const range = document.createRange();
          range.selectNodeContents(this.querySelector('[data-scratch-code]'));
          selection?.removeAllRanges();
          selection?.addRange(range);
          this.status.textContent = this.dataset.copyError || 'Copy unavailable. Please select and copy the code.';
        }
      }

      async sendMail(event) {
        event.preventDefault();
        const form = this.mail, input = form.querySelector('input[type=email]'), button = form.querySelector('button[type=submit]'), msg = form.querySelector('.cl-scratch-mail__msg');
        if (!input || !button) return;
        clearTimeout(this.redirectTimer);
        const email = input.value.trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { msg.textContent = 'Please enter a valid email.'; input.focus(); return; }
        button.disabled = true; msg.textContent = 'Sending…';
        try {
          const res = await fetch(form.action, { method: 'POST', body: new FormData(form), credentials: 'same-origin' });
          if (res.redirected && /\/challenge/.test(res.url)) { HTMLFormElement.prototype.submit.call(form); return; }   // spam check: finish it on Shopify's page
          if (!res.ok) throw new Error(res.status);
          form.querySelector('.cl-scratch-mail__row').hidden = true;
          form.querySelector('.cl-scratch-mail__note').hidden = true;
          form.querySelector('.cl-scratch-mail__label').hidden = true;
          msg.textContent = 'Saved. Check your inbox for your code.';
          try { localStorage.setItem('cl-scratch-mailed', '1'); } catch (_) {}
        } catch (_) {
          button.disabled = false;
          msg.textContent = 'Could not send right now. Your code is shown above.';
        }
      }

      destroy() {
        if (!this.controller) return;
        this.controller.abort();
        this.controller = null;
        cancelAnimationFrame(this.frame);
        clearTimeout(this.fadeTimer);
        clearTimeout(this.copyTimer);
        clearTimeout(this.redirectTimer);
        this.showNormally();
        this.copyButton.removeAttribute('data-copied');
        this.copyButton.removeAttribute('aria-label');
        this.removeAttribute('data-highlight');
        this.copying = false;
      }
    }
    customElements.define('cleveree-scratch', ClevereeScratch);
    document.addEventListener('shopify:section:load', (event) => {
      event.target.querySelectorAll('cleveree-scratch').forEach((element) => element.init());
    });
    document.addEventListener('shopify:section:unload', (event) => {
      event.target.querySelectorAll('cleveree-scratch').forEach((element) => element.destroy());
    });
  }
  } catch(e) { console.error(e); }
})();

})();
